import React from 'react';
import axios from 'axios';

import Portal from 'react-portal';
import FullScreenOverlay from '../../components/FullScreenOverlay.js';
import SegmentsNew from "../../containers/segments/SegmentsNew";

class Rule extends React.Component {
    constructor(props) {
        super(props);
        this.defaultState = this.defaultState.bind(this);
        this.editDropdown = this.editDropdown.bind(this);
        this.renderDropdown = this.renderDropdown.bind(this);
        this.changeDropdown = this.changeDropdown.bind(this);
        this.createSegment = this.createSegment.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.defaultState();
    }

    handleSave(segment) {
        this.setState({
            segment
        });

        this.changeDropdown(segment.id);
    }

    createSegment() {
        this.setState({
            createSegment:!this.state.createSegment
        });
    }

    changeDropdown(value) {
        this.props.setGlobalTypeState('rules',this.props.rule.id,{'value':value});
        this.setState({value:value});
        this.setState({'isEditingDropdown':!this.state.isEditingDropdown});
    }

    displayText(value) {
        if(this.state.isLoading) {
            return 'Loading..';
        }

        if(!this.state.segment) {
            return 'None';
        }

        return this.state.segment.name;

    }

    renderDropdown() {
        return (
            <div className="dropdown open">
                <button type="button" className="btn btn-dark dropdown-toggle btn-sm" aria-expanded="true" data-toggle="dropdown">
                    {this.displayText(this.state.value)}
                    <span className="caret"></span>
                </button>
                <div className="dropdown-menu">
                    <a href="javascript:void(0)" onClick={e => {e.stopPropagation(); this.createSegment()}} className="dropdown-item" role="button" tabIndex="-1">Create new segment</a>
                    {
                        this.state.segment ?
                            <a href="javascript:void(0)" onClick={e => {e.stopPropagation(); this.createSegment()}} className="dropdown-item" role="button" tabIndex="-1">Edit current segment</a>:null
                    }
                </div>
            </div>
        );
    }

    editDropdown() {
        this.setState({'isEditingDropdown':!this.state.isEditingDropdown});
    }

    defaultState(props) {
        this.state = {
            'isEditingDropdown':false,
            'value':this.props.onlyDescription ? false:this.props.rule.value,
            'segment':false,
            'isLoading':true,
            'createSegment':false,
        };
    }


    componentWillMount() {
        if(this.props.rule.value != 0) {
            axios.get('/segments/'+this.props.rule.value).then(res => {
                this.setState({
                    isLoading:false,
                    segment:res.data
                })
            });
        }else{
            this.setState({
                isLoading:false,
            })
        }
    }


    render() {
        if(this.props.onlyDescription) {
            return <li></li>;
        }

        return (
            <div className="list-group-item blue-grey-500">
                <i className="icon wb-arrow-right" aria-hidden="true"></i>
                Send to customers matching segment: &nbsp;
                {
                    !this.state.isEditingDropdown
                        ?
                        <span onClick={(e) => {e.stopPropagation();this.editDropdown(e);} } className="selected-rule">{this.displayText(this.props.rule.value)}</span>
                        :this.renderDropdown()
                }
                <Portal closeOnEsc onClose={e => {this.setState({createSegment:false})}} isOpened={this.state.createSegment}>
                    <FullScreenOverlay zIndex="99999">
                        <SegmentsNew handleSave={this.handleSave} segmentId={this.state.segment ? this.state.segment.id : false} onClose={e => {this.setState({createSegment:false})}}  />
                    </FullScreenOverlay>
                </Portal>
            </div>
        );
    }


}

export default Rule;




// WEBPACK FOOTER //
// ./components/builder/RuleSendToSegmentEvent.js